import { axios } from "@/plugins/axios";

function getChecklists() {
    return axios.post("?Mode=MeinServicebereich&Function=GetCheckLists");
}

function uploadChecklist(description, checklistItemId, checklistfile) {
    var formData = new FormData();
    formData.append("description", description);
    formData.append("checklistItemId", checklistItemId);
    formData.append("checklistfile", checklistfile);
    return axios.post(
        "?Mode=MeinServicebereich&Function=UploadCheckListDocument",
        formData
    );
}

function deleteChecklist(documentId) {
    return axios.post(
        "?Mode=MeinServicebereich&Function=DeleteCheckListDocument",
        "DocumentId=" + documentId
    );
}

export { getChecklists, uploadChecklist, deleteChecklist };
